import { Route } from '@angular/router';
import { initialDataResolver } from './app.resolvers';
import { AuthGuard } from '@core/auth/guards/auth.guard';
import { RoleGuard } from '@core/auth/guards/role.guard';
import { NotFoundComponent } from '@modules/errors/not-found/not-found.component';

// @formatter:off
/* eslint-disable max-len */
/* eslint-disable @typescript-eslint/explicit-function-return-type */
export const appRoutes: Route[] = [
    // Redirect empty path to '/example'
    { path: '', pathMatch: 'full', redirectTo: 'home' },

    // Redirect signed-in user to the '/example'
    //
    // After the user signs in, the sign-in page will redirect the user to the 'signed-in-redirect'
    // path. Below is another redirection for that path to redirect the user to the desired
    // location. This is a small convenience to keep all main routes together here on this file.
    { path: 'signed-in-redirect', pathMatch: 'full', redirectTo: 'home' },

    // Auth routes for guests
    {
        path: '',
        loadComponent: () =>
            import('@layout/layout.component').then(
                (m) => m.LayoutComponent
            ),
        data: {
            layout: 'empty',
        },
        children: [
            {
                path: 'confirmation-required',
                loadChildren: () =>
                    import(
                        '@modules/auth/confirmation-required/confirmation-required.routes'
                    ),
            },
            {
                path: 'forgot-password',
                loadChildren: () =>
                    import(
                        '@modules/auth/forgot-password/forgot-password.routes'
                    ),
            },
            {
                path: 'sign-in',
                loadChildren: () =>
                    import('@modules/auth/sign-in/sign-in.routes'),
            },
        ],
    },

    // Auth routes for authenticated users
    {
        path: '',
        canActivate: [AuthGuard],
        canActivateChild: [AuthGuard],
        loadComponent: () =>
            import('@layout/layout.component').then(
                (m) => m.LayoutComponent
            ),
        data: {
            layout: 'empty',
        },
        children: [
            {
                path: 'sign-out',
                loadChildren: () =>
                    import('@modules/auth/sign-out/sign-out.routes'),
            },
            {
                path: 'reset-password',
                loadChildren: () =>
                    import(
                        '@modules/auth/reset-password/reset-password.routes'
                    ),
            },
            //{path: 'unlock-session', loadChildren: () => import('@modules/auth/unlock-session/unlock-session.routes')}
        ],
    },

    // Admin routes
    {
        path: '',
        canActivate: [AuthGuard],
        canActivateChild: [AuthGuard],
        loadComponent: () =>
            import('@layout/layout.component').then(
                (m) => m.LayoutComponent
            ),
        resolve: {
            initialData: initialDataResolver,
        },
        children: [
            {
                path: 'home',
                loadChildren: () => import('@modules/home/home.routes'),
            },
            {
                path: 'data-settings/models',
                canActivate: [RoleGuard],
                data: { roles: ['Admin'] },
                loadChildren: () =>
                    import('@modules/modelling/modeling.routes'),
            },
            {
                path: 'data-management/ingestions',
                loadChildren: () =>
                    import('@modules/data-ingestion/data-ingestion.routes'),
            },
            {
                path: 'data-management/datasets',
                loadChildren: () =>
                    import('@modules/data-set/data-set.routes'),
            },
            {
                path: 'data-management/playground',
                loadChildren: () =>
                    import('@modules/playground/playground.routes'),
            },
            {
                path: 'data-management/dashboard-builder',
                loadChildren: () =>
                    import(
                        '@modules/dashboard-builder/dashboard-builder.routes'
                    ),
            },
            {
                path: 'data-management/dashboards',
                loadChildren: () =>
                    import('@modules/dashboard/dashboard.routes'),
            },
            {
                path: 'data-management/graphic-templates',
                loadChildren: () =>
                    import(
                        '@modules/graphic-template/graphic-template.routes'
                    ),
            },
            {
                path: 'data-management/documents',
                loadChildren: () =>
                    import('@modules/document/document.routes'),
            },
            {
                path: 'user-management/users',
                canActivate: [RoleGuard],
                data: { roles: ['Admin'] },
                loadChildren: () => import('@modules/user/user.routes'),
            },
            {
                path: 'parameters/companies',
                canActivate: [RoleGuard],
                data: { roles: ['Admin'] },
                loadChildren: () =>
                    import('@modules/company/company.routes'),
            },
            {
                path: 'parameters/company-domains',
                canActivate: [RoleGuard],
                data: { roles: ['Admin'] },
                loadChildren: () =>
                    import('@modules/company-domain/company-domain.routes'),
            },
            {
                path: 'parameters',
                canActivate: [RoleGuard],
                data: { roles: ['Admin'] },
                loadChildren: () =>
                    import('@modules/parameter/parameter.routes'),
            },
            {
                path: 'user-management/companies',
                canActivate: [RoleGuard],
                data: { roles: ['Admin'] },
                loadChildren: () =>
                    import('@modules/company/company.routes'),
            },
            {
                path: 'subscriptions',
                loadChildren: () =>
                    import('@modules/subscription/subscription.routes'),
            },
            {
                path: 'parameters/localities',
                loadChildren: () =>
                    import('@modules/country/country.routes'),
            },
            {
                path: 'data-management/database-extractions',
                loadChildren: () =>
                    import('@modules/database-extraction/database-extraction.routes'),
            },
        ],
    },
    // Route wildcard — ARCH-003 : toute URL inconnue affiche la page 404
    { path: '**', component: NotFoundComponent },
];
